import ListSeparator from '@/domain/navigation/features/search/components/ListSeparator';
import MitarbeiterResultItem from '@/domain/navigation/features/search/components/MitarbeiterResultItem';
import StandortResultItem from '@/domain/navigation/features/search/components/StandortResultItem';
import {
  MitarbeiterResult,
  StandortResult,
} from '@/domain/navigation/features/search/types/resultItem';
import { useTranslation } from 'react-i18next';

export function ResultList({
  results,
  handleClose,
}: {
  results: (MitarbeiterResult | StandortResult)[];
  handleClose: (value: boolean) => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="w-72 max-h-72 inline-flex flex-col justify-start items-start overflow-auto">
      {results.map((result, idx) => {
        if (result instanceof StandortResult) {
          if (idx === results.length - 1) {
            return (
              <StandortResultItem
                handleClose={handleClose}
                key={result.id}
                standort={result}
              />
            );
          }
          return (
            <>
              <StandortResultItem
                handleClose={handleClose}
                key={result.id}
                standort={result}
              />
              <ListSeparator key={`${result.id}-seperator`} />
            </>
          );
        }
        if (result instanceof MitarbeiterResult) {
          if (idx === results.length - 1) {
            return (
              <MitarbeiterResultItem
                key={result.id}
                mitarbeiterResult={result}
              />
            );
          }
          return (
            <>
              <MitarbeiterResultItem
                key={result.id}
                mitarbeiterResult={result}
              />
              <ListSeparator key={`${result.id}-seperator`} />
            </>
          );
        }
      })}
      {results.length === 0 && (
        <p className="w-full text-center text-neutrals-700 text-sm">
          {t('domain.navigation.suche.keineErgebnisse')}
        </p>
      )}
    </div>
  );
}
